export const CHAIN_CHANGE_ALREADY_PROCCESS_ERROR = 'Please check metamask. Another request for changing chain wait your action'